<template>
    <div class="Page">
        <Header Act="1"></Header>
        <div class="MaxWid">
            <div class="NewsList">
                <div class="NewsListTitle">新闻动态</div>
                <div class="NewsListContent">
                    <div class="NewsItem" v-for="item in NewsData" :key="item.id" @click="GoDetail(item)">
                        <div class="NewsItemRight" v-if="item.img">
                            <img :src="$Global.CommImgHttp + item.img" alt="">
                        </div>
                        <div class="NewsItemLeft">
                            <div class="NewsTitle">{{item.title || item.name}}</div>
                            <div class="NewsBrief Text2" v-if="item.content" v-html="item.content"></div>
                        </div>
                        <div class="NewsTime">
                            {{formatTime(item.updatetime || item.createtime)}}
                        </div>
                    </div>
                </div>
                <div class="PageDis">
                    <el-pagination
                        background
                        :page-sizes="[10, 20, 50]"
                        layout="prev,pager,next,total,sizes"
                        @size-change="SizeChange"
                        @current-change="PageChange"
                        :total="total"
                        :current-page="page"
                        :page-size="pageSize"
                        :hide-on-single-page="false">
                    </el-pagination>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/header/head';
import Footer from '@/components/header/footer';

export default {
    components: {
        Header,
        Footer
    },
    data() {
        return {
            NewsData: [],
            total: 0,
            page: 1,
            pageSize: 10
        }
    },
    mounted() {
        this.GetNewsList();
    },
    methods: {
        GetNewsList() {
            this.$get("api/index/newsList", {
                page: this.page,
                limit: this.pageSize
            }).then(res => {
                if(res.data.code == 1) {
                    this.NewsData = res.data.data.data;
                    this.total = res.data.data.total;
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        SizeChange(val) {
            this.pageSize = val;
            this.GetNewsList();
        },
        PageChange(val) {
            this.page = val;
            this.GetNewsList();
        },
        GoDetail(item) {
            const info = { ...item };
            // 确保详情页可用字段
            if(!info.name && info.title){
                info.name = info.title;
            }
            if(!info.updatetime && info.createtime){
                info.updatetime = info.createtime;
            }
            // 同时保存到localStorage（向后兼容）和通过路由参数传递
            localStorage.setItem("Info", JSON.stringify(info));
            localStorage.setItem("InfoState", 6);
            this.$router.push({
                path: '/InfoDetail',
                query: {
                    id: item.id,
                    type: 6  // 6=新闻动态
                }
            });
        },
        formatTime(timestamp) {
            if (!timestamp) return '';
            const date = new Date(timestamp * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
    }
}
</script>

<style scoped>
.Page {
    background: #fff;
}

.MaxWid {
    max-width: 1180px;
    padding: 0 10px;
    margin: 0 auto;
}

.NewsList {
    margin: 20px 0;
}

.NewsListTitle {
    font-size: 24px;
    color: #235da7;
    font-weight: bold;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #394788;
}

.NewsListContent {
    background: #fff;
}

.NewsItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
}

.NewsItem:hover {
    background: #f5f5f5;
}

.NewsItemLeft {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-right: 20px;
}

.NewsTitle {
    font-size: 16px;
    color: #333;
    font-weight: bold;
}

.NewsBrief {
    margin-top: 6px;
    color: #666;
    font-size: 14px;
    line-height: 1.5;
}

.NewsItemRight {
    width: 80px;
    height: 80px;
    margin-left: 20px;
}

.NewsItemRight img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.NewsTime {
    margin-left: 20px;
    color: #999;
    font-size: 14px;
    white-space: nowrap;
}

.PageDis {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    padding: 20px 0;
}
</style>

